var _ellipse, _ellipse2, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgToday(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0.56 0.56 51.89 51.99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 26.5,
    cy: 26.5536,
    rx: 25.5,
    ry: 25.5536,
    fill: "#F7F7F7",
    fillOpacity: 0.1,
    stroke: "#0DC2CD",
    strokeWidth: 0.8875
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 26.4999,
    cy: 26.5533,
    rx: 22.6132,
    ry: 22.6607,
    fill: "#0DC2CD",
    fillOpacity: 0.15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.8398 21.4102C34.8398 20.1727 33.8294 19.1602 32.5945 19.1602H29.2266V21.4102H32.5945V24.3914L28.6877 29.2852H24.736V23.6602H20.2454C17.7644 23.6602 15.7549 25.6739 15.7549 28.1602V31.5352H18.0002C18.0002 33.4027 19.5045 34.9102 21.3681 34.9102C23.2317 34.9102 24.736 33.4027 24.736 31.5352H29.7655L34.8398 25.1789V21.4102ZM21.3681 32.6602C20.7506 32.6602 20.2454 32.1539 20.2454 31.5352H22.4907C22.4907 32.1539 21.9855 32.6602 21.3681 32.6602Z",
    fill: "#0DC2CD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.123 20.2852H24.7363V22.5352H19.123V20.2852ZM34.84 28.1602C32.9764 28.1602 31.4721 29.6677 31.4721 31.5352C31.4721 33.4027 32.9764 34.9102 34.84 34.9102C36.7036 34.9102 38.208 33.4027 38.208 31.5352C38.208 29.6677 36.7036 28.1602 34.84 28.1602ZM34.84 32.6602C34.2226 32.6602 33.7174 32.1539 33.7174 31.5352C33.7174 30.9164 34.2226 30.4102 34.84 30.4102C35.4575 30.4102 35.9627 30.9164 35.9627 31.5352C35.9627 32.1539 35.4575 32.6602 34.84 32.6602Z",
    fill: "#0DC2CD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToday);
export default __webpack_public_path__ + "static/media/today.b8db55d3a34ae7ebc87c859a257bb595.svg";
export { ForwardRef as ReactComponent };